import {
  RefObject,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { VirtuosoHandle } from 'react-virtuoso';

import { isRunExecuting } from '@/Pages/Graph/src/control/state.utils';
import { usePrevious } from '@/hooks/usePrevious';

import { StateContext } from '../../../../control/state';

export const useAutoScrollThreadLog = ({
  ref,
  lastIndex,
  isAtBottom,
}: {
  ref: RefObject<VirtuosoHandle>;
  lastIndex: number;
  isAtBottom: boolean;
}) => {
  const { traceLog, runState } = useContext(StateContext);
  const isRunning = isRunExecuting(runState);

  const [shouldScrollToLast, setShouldScrollToLast] = useState(false);
  const prevIsAtBottom = usePrevious(isAtBottom);
  useLayoutEffect(() => {
    if (!isRunning) return;
    if (!isAtBottom && !prevIsAtBottom) return;
    ref.current?.scrollToIndex({
      index: 'LAST',
      align: 'end',
      behavior: 'auto',
    });
  }, [traceLog, ref, isAtBottom, prevIsAtBottom, isRunning]);

  useEffect(() => {
    if (shouldScrollToLast) {
      ref.current?.scrollToIndex({
        index: lastIndex,
      });
      setShouldScrollToLast(false);
    }
  }, [shouldScrollToLast, ref, lastIndex]);

  return {
    shouldScrollToLast,
    setShouldScrollToLast,
  };
};
